<template>
    <div class="data-actions">
        <div class="actions-row">
            <CsvUploadZone
                :project-id="projectId"
                :has-data="rowCount > 0"
                @uploaded="$emit('upload-csv')"
                @needs-confirmation="onNeedsConfirmation"
            />

            <div class="actions-buttons">
                <PrimeButton
                    v-if="hasFields"
                    label="Скачать шаблон CSV"
                    icon="pi pi-download"
                    class="p-button-sm p-button-outlined"
                    @click="$emit('download-template')"
                />

                <PrimeButton
                    label="Скачать все PDF"
                    icon="pi pi-file-pdf"
                    class="p-button-sm p-button-outlined"
                    @click="$emit('download-all')"
                />

                <div class="filename-select">
                    <span>Имя файла из колонки:</span>
                    <PrimeDropdown
                        :modelValue="filenameKey"
                        :options="filenameOptions"
                        optionLabel="label"
                        optionValue="value"
                        @update:modelValue="$emit('update:filename-key', $event)"
                        class="p-dropdown-sm"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CsvUploadZone from './CsvUploadZone.vue';

export default {
    name: "DataActions",
    components: {
        CsvUploadZone
    },
    props: {
        projectId: {
            type: Number,
            required: true
        },
        filenameKey: {
            type: String,
            default: 'row'
        },
        filenameOptions: {
            type: Array,
            default: () => []
        },
        rowCount: {
            type: Number,
            default: 0
        },
        hasFields: {
            type: Boolean,
            default: false
        }
    },
    emits: ['update:filename-key', 'download-template', 'download-all', 'upload-csv', 'needs-confirmation'],
    methods: {
        onNeedsConfirmation(data) {
            this.$emit('needs-confirmation', data);
        }
    }
}
</script>

<style scoped>
.data-actions {
    padding: 16px;
    background: #f8f9fa;
    border-radius: 8px;
}

.actions-row {
    display: flex;
    gap: 24px;
    align-items: flex-start;
}

.actions-buttons {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.filename-select {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 8px;
}

.filename-select span {
    font-size: 0.9rem;
    color: #6c757d;
}
</style>
